import React from "react";
import ReactDOM from "react-dom";

import axios from "axios";

export default class SelectionDepartement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            config: JSON.parse(this.props.config),
            locas: JSON.parse(this.props.loca),
            sub:JSON.parse(this.props.sub),
            newLoca:[],
            depart:[],
            changeDepart:"default",
            prixTotalTTC:0,
            prixMulti:false,
            messageFlash:"",
            openFlash:false,
        }
        this.handleChangeDepartement = this.handleChangeDepartement.bind(this);
        this.handleFlashCloseProjet = this.handleFlashCloseProjet.bind(this);
        this.handleDeleteDepart = this.handleDeleteDepart.bind(this);
        this.handleOpenPayment = this.handleOpenPayment.bind(this);
    }
    componentDidMount() {
        let {locas} = this.state;
        let tab = null;
        let newTab = [];
        tab = locas.filter(value => value.code_departement !== "");
        tab = tab.filter(value => value.code_departement !== null);

        tab.map(value => {
            if(value.code_departement.length === 1){
                let nb = "0"+value.code_departement;
                newTab.push(nb);
            }else{
                newTab.push(value.code_departement);
            }
        })
        const test = newTab.sort((a, b) => {
            if (a === "2B" || b === "2A") {
                return -1;
            }
            if (a === "2A" || b === "2B") {
                return -1;
            }
            return +a - +b;
        });

        this.setState({newLoca:test});
    }
    handleChangeDepartement(e){
        e.preventDefault();
        let {depart,changeDepart,config,sub,prixTotalTTC} = this.state;
        let element =[];
        if(depart.length > 0){
            this.setState({messageFlash:"Vous ne pouvez prendre qu'un abonnement à la fois.",openFlash:true})
        }else{
            if(sub.length > 0){
                element.push(changeDepart);
                element.push(config.comp);
                element.push(config.compToken);
                prixTotalTTC = parseInt(config.comp) * 1.2
                prixTotalTTC = this.financial(prixTotalTTC);
            }else{
                element.push(changeDepart);
                element.push(config.abo);
                element.push(config.aboToken);
                prixTotalTTC = parseInt(config.abo) * 1.2
                prixTotalTTC = this.financial(prixTotalTTC);
            }
            depart.push(element);
        }
        this.setState({depart,changeDepart:"default",prixTotalTTC});
    }
    handleDeleteDepart(e,index){
        e.preventDefault();
        this.setState({depart:[]});
    }
    handleFlashCloseProjet(e){
        e.preventDefault();
        this.setState({messageFlash:"",openFlash:false})
    }
    handleOpenPayment(e){
        e.preventDefault();
        document.getElementById('paimentBlock').style.display = "block";
    }
    financial(x) {
        return Number.parseFloat(x).toFixed(2);
    }
    render(){
        let {newLoca} = this.state;
        return (
            <>
               <div className="from-control">
                   <h2>Selectioner un département</h2>
                    <select className="departementSelect" value={this.state.changeDepart} onChange={(e) => this.setState({changeDepart:e.target.value})}>
                        <option value="default" >Choisir un département</option>
                        {
                            this.state.newLoca.map((value,index) => (
                                <option key={index}>{value}</option>
                                ))
                            }
                    </select>
                    <a href="" onClick={(e) => this.handleChangeDepartement(e)} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.013" height="15.013" viewBox="0 0 15.013 15.013">
                            <g id="Icon_ionic-md-add-circle-outline" data-name="Icon ionic-md-add-circle-outline" transform="translate(-3.375 -3.375)">
                                <path id="Tracé_8" data-name="Tracé 8" d="M18.2,15.1H15.1v3.1H13.58V15.1h-3.1V13.58h3.1v-3.1H15.1v3.1h3.1Z" transform="translate(-3.457 -3.457)" fill="#2f2f2f"/>
                                <path id="Tracé_9" data-name="Tracé 9" d="M10.881,4.891A5.988,5.988,0,1,1,6.645,6.645a5.966,5.966,0,0,1,4.237-1.754m0-1.516a7.506,7.506,0,1,0,7.506,7.506,7.505,7.505,0,0,0-7.506-7.506Z" fill="#2f2f2f"/>
                            </g>
                        </svg>
                       <span>Ajouter</span>
                    </a>
               </div>
               <div className="listeDepartementSelect">
                    <h2>Liste des départements sélectionnés</h2>
                    <div className="listeDepartementHeader">
                        <div className="blockDepart">
                            <p>Département</p>
                        </div>
                        <div className="blockPrix">
                            <p>Prix en € HT</p>
                        </div>
                    </div>
                    <div className="listeDepartementBody">
                        {
                            this.state.depart.map((value,index) => (
                                <div key={index}>
                                    <div className="blockDepart">
                                        <p>{value[0]}</p>
                                    </div>
                                    <div className="blockPrix">
                                        <p>{this.financial(value[1])}</p>
                                        <a href="" onClick={(e) => this.handleDeleteDepart(e,index)} >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 2.25C9.58579 2.25 9.25 2.58579 9.25 3V3.75H5C4.58579 3.75 4.25 4.08579 4.25 4.5C4.25 4.91421 4.58579 5.25 5 5.25H19C19.4142 5.25 19.75 4.91421 19.75 4.5C19.75 4.08579 19.4142 3.75 19 3.75H14.75V3C14.75 2.58579 14.4142 2.25 14 2.25H10Z" />
                                            <path d="M10 10.65C10.4142 10.65 10.75 10.9858 10.75 11.4L10.75 18.4C10.75 18.8142 10.4142 19.15 10 19.15C9.58579 19.15 9.25 18.8142 9.25 18.4L9.25 11.4C9.25 10.9858 9.58579 10.65 10 10.65Z" />
                                            <path d="M14.75 11.4C14.75 10.9858 14.4142 10.65 14 10.65C13.5858 10.65 13.25 10.9858 13.25 11.4V18.4C13.25 18.8142 13.5858 19.15 14 19.15C14.4142 19.15 14.75 18.8142 14.75 18.4V11.4Z" />
                                            <path  d="M5.99142 7.91718C6.03363 7.53735 6.35468 7.25 6.73684 7.25H17.2632C17.6453 7.25 17.9664 7.53735 18.0086 7.91718L18.2087 9.71852C18.5715 12.9838 18.5715 16.2793 18.2087 19.5446L18.189 19.722C18.045 21.0181 17.0404 22.0517 15.7489 22.2325C13.2618 22.5807 10.7382 22.5807 8.25108 22.2325C6.95954 22.0517 5.955 21.0181 5.81098 19.722L5.79128 19.5446C5.42846 16.2793 5.42846 12.9838 5.79128 9.71852L5.99142 7.91718ZM7.40812 8.75L7.2821 9.88417C6.93152 13.0394 6.93152 16.2238 7.2821 19.379L7.3018 19.5563C7.37011 20.171 7.84652 20.6612 8.45905 20.747C10.8082 21.0758 13.1918 21.0758 15.5409 20.747C16.1535 20.6612 16.6299 20.171 16.6982 19.5563L16.7179 19.379C17.0685 16.2238 17.0685 13.0394 16.7179 9.88417L16.5919 8.75H7.40812Z" />
                                        </svg>

                                        </a>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="listeDepartementFooter">
                    <div className="blockDepart">
                            <p>Total TTC</p>
                        </div>
                        <div className="blockPrix">
                            <p>{this.state.prixTotalTTC}</p>
                            <div className="hiddenBlockReplace"></div>
                        </div>
                    </div>
                    <div className="openPayment">
                        <a href="" onClick={(e) => this.handleOpenPayment(e)}>Passer au mode de paiement <span>></span></a>
                    </div>
                    <input type="hidden" value={JSON.stringify(this.state.depart)} name="card" />
               </div>
               {/* MODAL Flash MESSAGE */}
               {
                    this.state.openFlash &&
                        <div className="modal modalDelete">
                            <div className="backgroundModal">
                                <div className="contentModal">
                                    <div className="message">
                                        <p>{this.state.messageFlash}</p>
                                    </div>
                                    <div className="action blue">
                                        <a href="" onClick={(e) => this.handleFlashCloseProjet(e)}>OK</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </>
        )
    }
}
if (document.getElementById('selectionDepartement')) {
    const element = document.getElementById('selectionDepartement');
    let props = Object.assign({}, element.dataset);
    ReactDOM.render(<SelectionDepartement {...props}/>, document.getElementById('selectionDepartement'));
}
